// Expected digit length for a full number; callers validate separately.
export const GIFT_CARD_NUMBER_LENGTH = 16

// Strip non-digits from raw input (use on controlled field change).
export function normalizeGiftCardNumberInput(value: string): string {
  return value.replace(/[^0-9]/g, "")
}

// Format digits as spaced groups for the input `value` only, not general display.
export function formatGiftCardNumberInputDisplay(digits: string): string {
  const cleaned = normalizeGiftCardNumberInput(digits)
  if (cleaned.length === 0) {
    return ""
  }
  const groups: string[] = []
  for (let i = 0; i < cleaned.length; i += 4) {
    groups.push(cleaned.slice(i, i + 4))
  }
  return groups.join(" ")
}
